import DetailContent from "../components/DetailContent/DetailContent";
import HeroSection from "../components/HeroSection/HeroSection";
import Layout from "../components/Layout/Layout";

const DetailPage = () => {
    return(
    <Layout>
        <HeroSection />
        <DetailContent />
    </Layout>
)
}

export default DetailPage;